(() => {
  const page = document.querySelector('[data-cart-page]');
  if (!page) return;

  const root = window.Shopify?.routes?.root || '/';
  const errorNode = page.querySelector('[data-cart-page-error]');
  const bundleIdFor = (item) => item.properties?._bundleId || item.properties?.bundleId;

  const showError = (message) => {
    if (!errorNode) return;
    errorNode.textContent = message || 'Your bag could not be updated. Please try again.';
    errorNode.hidden = false;
  };

  const requestJson = async (url, options = {}) => {
    const response = await fetch(url, {
      ...options,
      headers: { Accept: 'application/json', ...(options.headers || {}) }
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || 'Your bag could not be updated.');
    return result;
  };

  page.addEventListener('click', async (event) => {
    const bundleButton = event.target.closest('[data-cart-page-remove-bundle]');
    const itemButton = event.target.closest('[data-cart-page-item-key]');
    if (!bundleButton && !itemButton) return;

    event.preventDefault();
    const button = bundleButton || itemButton;
    button.disabled = true;
    if (errorNode) errorNode.hidden = true;

    try {
      if (bundleButton) {
        const cart = await requestJson(`${root}cart.js`);
        const updates = {};
        cart.items.forEach((item) => {
          if (bundleIdFor(item) === bundleButton.dataset.cartPageRemoveBundle) updates[item.key] = 0;
        });
        if (!Object.keys(updates).length) throw new Error('This set is no longer in your bag.');
        await requestJson(`${root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });
      } else {
        await requestJson(`${root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: itemButton.dataset.cartPageItemKey,
            quantity: Number(itemButton.dataset.cartPageQuantity)
          })
        });
      }

      window.location.reload();
    } catch (error) {
      button.disabled = false;
      showError(error.message);
    }
  });
})();
